import { createFileRoute } from '@tanstack/react-router';

import {
  HelpArticleEditPage,
  helpArticleQueryOptions,
  helpCategoriesQueryOptions,
} from '@/features/help-center';

export const Route = createFileRoute('/_authed/_active/s/$storeId/help/$articleId')({
  loader: async ({ context, params }) => {
    const [article] = await Promise.all([
      context.queryClient.query({
        ...helpArticleQueryOptions(params.storeId, params.articleId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...helpCategoriesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: article.title };
  },
  component: HelpArticleEditPage,
});
